import React, { useEffect, useMemo, useState } from "react";
import { Container, UncontrolledTooltip, Form, FormGroup, Label, Input, Button, Row, Col, Card, CardBody, Spinner } from "reactstrap";
import TableContainer from '../../../components/Common/TableContainer';

// Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import { Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import Select from 'react-select';
import { States, Countries } from "../../../common/data/constants"
import Swal from 'sweetalert2';
import { createUnit, fetchUnits } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const Unit = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const [isEdit, setIsEdit] = useState(false);
  const [unitId, setUnitId] = useState(false);

  const [authDetails, setAuthDetails] = useState(null);


  const dispatch = useDispatch();

  const { units, loading, error, success } = useSelector((state) => state.UnitMaster || {});

  // const columns = useMemo(() => [
  //   {
  //     Header: "Action",
  //     className: "serial-no",
  //     applyHeaderClass: true,
  //     Cell: (cellProps) => {
  //       const isActive = cellProps.row.original.isActive;
  //       return (
  //         <div className="d-flex gap-3">
  //           <Link
  //             to="#"
  //             className="text-success"
  //             onClick={() => handleEdit(cellProps.row.original)}
  //           >
  //             <i className="bx bxs-edit font-size-18" id="edittooltip" />
  //             <UncontrolledTooltip placement="top" target="edittooltip">
  //               Edit
  //             </UncontrolledTooltip>
  //           </Link>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     Header: "S.No",
  //     Cell: ({ row }) => units.length - row.index,
  //     className: "serial-no",
  //     applyHeaderClass: true,
  //   },
  //   {
  //     Header: "Unit Name",
  //     accessor: "unit_name",
  //   },
  //   {
  //     Header: "Short Name",
  //     accessor: "short_name",
  //   },
  //   {
  //     Header: "Unit Id",
  //     accessor: "unit_id",
  //   },
  //   {
  //     Header: "Address1",
  //     accessor: "address_1",
  //   },
  //   {
  //     Header: "Address2",
  //     accessor: "address_2",
  //   },
  //   {
  //     Header: "City",
  //     accessor: "city",
  //   },
  //   {
  //     Header: "Pin Code",
  //     accessor: "pin_code",
  //   },
  //   {
  //     Header: "State",
  //     accessor: "state_name",
  //   },
  //   {
  //     Header: "Country",
  //     accessor: "country_name",
  //   },
  //   {
  //     Header: "Phone",
  //     accessor: "phone",
  //   },
  //   {
  //     Header: "Mobile",
  //     accessor: "mobile",
  //   },
  //   {
  //     Header: "Fax",
  //     accessor: "fax",
  //   },
  //   {
  //     Header: "Email",
  //     accessor: "email",
  //   },
  //   // {
  //   //   Header: "Created By",
  //   //   accessor: "createdBy",
  //   // },
  //   // {
  //   //   Header: "Created On",
  //   //   accessor: "createdOn",
  //   //   Cell: ({ value }) => {
  //   //     // Format createdOn to DD-MM-YYYY
  //   //     const date = new Date(value);
  //   //     const formattedDate = `${String(date.getDate()).padStart(2, "0")}-${String(
  //   //       date.getMonth() + 1
  //   //     ).padStart(2, "0")}-${date.getFullYear()}`;
  //   //     return formattedDate;
  //   //   },
  //   //},
  // ]);

  // const columns = useMemo(() => {
  //   const actionColumn = {
  //     Header: "Action",
  //     className: "serial-no",
  //       applyHeaderClass: true,
  //       Cell: (cellProps) => {
  //         const id = `edittooltip-${cellProps.row.index}`;

  //         return (
  //           <div className="d-flex gap-3">
  //             {canEdit && (
  //               <button
  //                 type="button"
  //                 className="text-success bg-transparent border-0 p-0"
  //                 onClick={() => handleEdit(cellProps.row.original)}
  //                 style={{ cursor: "pointer" }}
  //               >
  //                 <i className="bx bxs-edit font-size-18" id={id} />
  //               </button>
  //             )}

  //             {/* {canDelete && (
  //             <Link
  //               to="#"
  //               className="text-danger"
  //               onClick={() => {
  //                 handleToggleStatus(cellProps.row.original);
  //               }}
  //             >
  //               <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
  //               <UncontrolledTooltip placement="top" target="deletetooltip">
  //                 Delete
  //               </UncontrolledTooltip>
  //             </Link>
  //           )} */}
  //           </div>
  //         );
  //       },
  //   };
  const columns = useMemo(() => {
    const actionColumn = {
      Header: "Action",
      className: "serial-no",
      applyHeaderClass: true,
      Cell: (cellProps) => {
        const { unit_id, unit_name, isActive } = cellProps.row.original;
        const tooltipId = `status-tooltip-${unit_id}`;

        return (
          <div className="d-flex gap-3 justify-content-center">
            {/* Edit button */}
            {canEdit && (
              <button
                type="button"
                className="text-success bg-transparent border-0 p-0"
                onClick={() => handleEdit(cellProps.row.original)}
                style={{ cursor: "pointer" }}
              >
                <i className="bx bxs-edit font-size-18" id={`edittooltip-${unit_id}`} />
              </button>
            )}

            {/* Active/Inactive toggle button */}
            {(canEdit || canDelete) && (
              <Link
                to="#"
                style={{
                  color: "green",          // ALWAYS green
                  cursor: "pointer"
                }}
                onClick={() => handleToggleStatus(unit_id, unit_name, isActive)}
              >
                <i
                  className="mdi mdi-check-circle font-size-18"
                  id={`status-tooltip-${unit_id}`}
                />
              </Link>
            )}

            <UncontrolledTooltip
              placement="top"
              target={`status-tooltip-${unit_id}`}
            >
              {isActive ? "Active" : "Activate"}
            </UncontrolledTooltip>
          </div>
        );
      },
    };

    const baseColumns = [
      {
        Header: "S.No",
        Cell: ({ row }) => units.length - row.index,
        className: "serial-no",
        applyHeaderClass: true,
      },
      { Header: "Unit Name", accessor: "unit_name" },
      { Header: "Short Name", accessor: "short_name" },
      { Header: "Unit Id", accessor: "unit_id" },
      { Header: "Address1", accessor: "address_1" },
      { Header: "Address2", accessor: "address_2" },
      { Header: "Address3", accessor: "address_3" },
      { Header: "Address4", accessor: "address_4" },
      { Header: "City", accessor: "city" },
      { Header: "Pin Code", accessor: "pin_code" },
      { Header: "State", accessor: "state_name" },
      { Header: "Country", accessor: "country_name" },
      { Header: "Phone", accessor: "phone" },
      { Header: "Mobile", accessor: "mobile" },
      { Header: "Fax", accessor: "fax" },
      { Header: "Email", accessor: "email" },
    ];

    // 👉 Add action column ONLY when one permission exists
    return (canEdit || canDelete) 
      ? [actionColumn, ...baseColumns] 
      : baseColumns;

  }, [units, canEdit, canDelete]);


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      unitName: units?.unitName || "",
      shortName: units?.short_name || "",
      address1: units?.address_1 || "",
      address2: units?.address_2 || "",
      address3: units?.address_3 || "",
      address4: units?.address_4 || "",
      city: units?.city || "",
      pinCode: units?.pin_code || "",
      country: units?.country || "",
      state: units?.state || "",
      phone: units?.phone || "",
      fax: units?.fax || "",
      mobile: units?.mobile || "",
      email: units?.email || "",
    },
    validationSchema: Yup.object({
      unitName: Yup.string()
        .required("Unit Name is required")
        .max(100, "Unit Name must not exceed 100 characters")
        .matches(/^[a-zA-Z0-9 ]+$/, "Only alphabets, numbers and spaces allowed"),

      shortName: Yup.string()
        .required("Short Name is required")
        .max(20, "Short Name must not exceed 20 characters")
        .matches(/^[a-zA-Z0-9 ]+$/, "Only alphabets, numbers and spaces allowed"),

      address1: Yup.string()
        .required("Address 1 is required")
        .max(100, "Address 1 must not exceed 100 characters")
        .matches(/^[a-zA-Z0-9 ]+$/, "Only alphabets, numbers and spaces allowed"),

      address2: Yup.string()
        .max(100, "Address 2 must not exceed 100 characters")
        .matches(/^[a-zA-Z0-9\s.,/#\-]+$/, "Invalid characters"),

      address3: Yup.string()
        .max(100, "Address 3 must not exceed 100 characters")
        .matches(/^[a-zA-Z0-9\s.,/#\-]+$/, "Invalid characters"),

      address4: Yup.string()
        .max(100, "Address 4 must not exceed 100 characters")
        .matches(/^[a-zA-Z0-9\s.,/#\-]+$/, "Invalid characters"),

      city: Yup.string()
        .required("City is required")
        .max(50, "City must not exceed 50 characters")
        .matches(/^[a-zA-Z ]+$/, "Only alphabets and spaces allowed"),

      pinCode: Yup.string()
        .required("Pin Code is required")
        .max(6, "Pin Code must not exceed 6 digits")
        .matches(/^[0-9]+$/, "Only numbers allowed"),

      state: Yup.number()
        .required("State is required")
        .typeError("Invalid State"),

      country: Yup.number()
        .required("Country is required")
        .typeError("Invalid Country"),

      phone: Yup.string()
        .max(15, "Phone must not exceed 15 digits")
        .matches(/^[0-9]*$/, "Only numbers allowed"),

      mobile: Yup.string()
        .max(15, "Mobile must not exceed 15 digits")
        .matches(/^[0-9]*$/, "Only numbers allowed"),

      fax: Yup.string()
        .max(15, "Fax must not exceed 15 characters")
        .matches(/^[0-9+\-(). ]*$/, "Invalid Fax number"),

      email: Yup.string()
        .max(50, "Email must not exceed 50 characters")
        .email("Invalid email format"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const formData = new FormData();
        formData.append("unit_name", values.unitName);
        formData.append("short_name", values.shortName);
        formData.append("address_1", values.address1) || "";
        formData.append("address_2", values.address2 || "");
        formData.append("address_3", values.address3)  || "";
        formData.append("address_4", values.address4)  || "";
        formData.append("city", values.city);
        formData.append("pin_code", values.pinCode);
        formData.append("state_id", values.state);
        formData.append("country_id", values.country);
        formData.append("phone", values.phone);
        formData.append("mobile", values.mobile);
        formData.append("fax", values.fax);
        formData.append("email", values.email);
        formData.append("created_by", authDetails.user_id);

        // Add or Update logic
        if (isEdit) {
          formData.append("unit_id", unitId);
          console.log("Updating data:", formData);
        } else {
          formData.append("unit_id", 0);
          console.log("Adding new data:", formData);
        }

        dispatch(createUnit(formData)); // Use the same action for both create and update

        formik.resetForm();
        setIsEdit(false);
      } catch (error) {
        console.log('error > ', error)
      } finally {
        setSubmitting(false);
      }
    }
  });

  // Fetch data on component mount
  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    console.log("Final Employee Object:", authUserDetails);
    dispatch(fetchUnits());
  }, [dispatch]);


  const handleEdit = (row) => {
    console.log("Editing row:", row);

    const selectedCountry = Countries.find(
      (c) => String(c.value) === String(row.country_id)
    ) || null;

    const selectedState = States.find(
      (s) => String(s.value) === String(row.state_id)
    ) || null;

    setUnitId(row.unit_id);
    formik.setValues({
      unitName: row.unit_name,
      shortName: row.short_name,
      address1: row.address_1 || "",
      address2: row.address_2 || "",
      address3: row.address_3 || "",
      address4: row.address_4 || "",
      city: row.city,
      pinCode: row.pin_code,
      country: selectedCountry ? selectedCountry.value : "", // Ensure string
      state: selectedState ? selectedState.value : "", // Ensure string
      phone: row.phone,
      fax: row.fax,
      mobile: row.mobile,
      email: row.email,
    });

    setIsEdit(true);
  };

const [loadingstatus, setLoadingStatus]=useState(null);

  const handleToggleStatus = (isActive) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to ${isActive ? 'deactivate' : 'activate'} ${unitName}.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      reverseButtons: false,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        //Swal.fire('Success!', `Unit is now ${isActive ? 'inactive' : 'active'}.`, 'success');
        setLoadingStatus(unitId);
        setTimeout(() => {
          Swal.fire('Success!', `${unitName} is now ${isActive ? 'inactive' : 'active'}.`, 'success');
          setLoadingStatus(null);
          dispatch(fetchUnits());
        }, 500);
      }
    });
  };



  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Setup" breadcrumbItem="Unit" />

          <Row>
            <Col lg="12">
            {(canCreate || canEdit) && (
              <Card>
                <CardBody>
                  <Form onSubmit={formik.handleSubmit}>
                    <Row>
                      {/* Unit Name Field */}
                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="unitName">
                            Unit Name <span className="text-danger">*</span>
                          </Label>
                          <Input
                            id="unitName"
                            name="unitName"
                            type="text"
                            maxLength={100}
                            value={formik.values.unitName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.unitName && formik.errors.unitName}
                          />
                          {formik.touched.unitName && formik.errors.unitName ? (
                            <div className="text-danger">{formik.errors.unitName}</div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      {/* Unit Code Field */}
                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="unitCode">
                            Short Name <span className="text-danger">*</span>
                          </Label>
                          <Input
                            id="shortName"
                            name="shortName"
                            type="text"
                            maxLength={20}
                            value={formik.values.shortName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.shortName && formik.errors.shortName}
                          />
                          {formik.touched.shortName && formik.errors.shortName ? (
                            <div className="text-danger">{formik.errors.shortName}</div>
                          ) : null}
                        </FormGroup>
                      </Col>



                      {/* Address1 Field */}
                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="address1">
                            Address 1 <span className="text-danger">*</span>
                          </Label>
                          <Input
                            id="address1"
                            name="address1"
                            type="text"
                            maxLength={100}
                            value={formik.values.address1}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.address1 && formik.errors.address1}
                          />
                          {formik.touched.address1 && formik.errors.address1 ? (
                            <div className="text-danger">{formik.errors.address1}</div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      {/* Address2 Field */}
                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="address2">
                            Address 2
                          </Label>
                          <Input
                            id="address2"
                            name="address2"
                            type="text"
                            maxLength={100}
                            value={formik.values.address2}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.address2 && formik.errors.address2}
                          />
                          {formik.touched.address2 && formik.errors.address2 ? (
                            <div className="text-danger">{formik.errors.address2}</div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="address1">
                            Address 3 
                          </Label>
                          <Input
                            id="address3"
                            name="address3"
                            type="text"
                            maxLength={100}
                            value={formik.values.address3}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.address3 && formik.errors.address3}
                          />
                          {formik.touched.address3 && formik.errors.address3 ? (
                            <div className="text-danger">{formik.errors.address3}</div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="address4">
                            Address 4
                          </Label>
                          <Input
                            id="address4"
                            name="address4"
                            type="text"
                            maxLength={100}
                            value={formik.values.address4}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.address4 && formik.errors.address4}
                          />
                          {formik.touched.address4 && formik.errors.address4 ? (
                            <div className="text-danger">{formik.errors.address4}</div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      {/* City Field */}
                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="city">
                            City <span className="text-danger">*</span>
                          </Label>
                          <Input
                            id="city"
                            name="city"
                            type="text"
                            maxLength={50}
                            value={formik.values.city}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.city && formik.errors.city}
                          />
                          {formik.touched.city && formik.errors.city ? (
                            <div className="text-danger">{formik.errors.city}</div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      {/* Pin Code Field */}
                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="pinCode">
                            Pin Code <span className="text-danger">*</span>
                          </Label>
                          <Input
                            id="pinCode"
                            name="pinCode"
                            type="text"
                            maxLength={6}
                            value={formik.values.pinCode}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.pinCode && formik.errors.pinCode}
                          />
                          {formik.touched.pinCode && formik.errors.pinCode ? (
                            <div className="text-danger">{formik.errors.pinCode}</div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="country">
                            Country <span className="text-danger">*</span>
                          </Label>
                          {/* <Select
                            id="country"
                            name="country"
                            options={Countries}
                            value={formik.values.country ? { value: formik.values.country, label: formik.values.country } : null}
                            onChange={(option) => formik.setFieldValue("country", option ? option.value : "")}
                            onBlur={formik.handleBlur}
                            isInvalid={formik.touched.country && formik.errors.country}
                          /> */}
                          <Select
                            id="country"
                            name="country"
                            options={Countries}
                            value={Countries.find((c) => c.value === formik.values.country) || null} // Find correct object
                            onChange={(option) => {
                              formik.setFieldValue("country", option.value); // Store only string
                            }}
                            onBlur={formik.handleBlur}
                            className="hrms-select"
                            classNamePrefix="hrms-select"
                          />

                          {formik.touched.country && formik.errors.country ? (
                            <div className="text-danger">{formik.errors.country}</div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      {/* // State Field */}
                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="state">
                            State <span className="text-danger">*</span>
                          </Label>
                          {/* <Select
                          id="state"
                          name="state"
                          options={States}
                          value={formik.values.state ? { value: formik.values.state, label: formik.values.state } : null}
                          onChange={(option) => formik.setFieldValue("state", option ? option.value : "")}
                          onBlur={formik.handleBlur}
                          isInvalid={formik.touched.state && formik.errors.state}
                        /> */}
                          <Select
                            id="state"
                            name="state"
                            options={States}
                            value={States.find((s) => s.value === formik.values.state) || null} // Find correct object
                            onChange={(option) => formik.setFieldValue("state", option.value)} // Store only string
                            onBlur={formik.handleBlur}
                            className="hrms-select"
                            classNamePrefix="hrms-select"
                          />
                          {formik.touched.state && formik.errors.state ? (
                            <div className="text-danger">{formik.errors.state}</div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      {/* Phone Field */}
                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="phone">
                            Phone
                          </Label>
                          <Input
                            id="phone"
                            name="phone"
                            type="text"
                            maxLength={15}
                            value={formik.values.phone}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.phone && formik.errors.phone}
                          />
                          {formik.touched.phone && formik.errors.phone ? (
                            <div className="text-danger">{formik.errors.phone}</div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="fax">
                            Fax
                          </Label>
                          <Input
                            id="fax"
                            name="fax"
                            type="text"
                            maxLength={15}
                            value={formik.values.fax}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.fax && formik.errors.fax}
                          />
                          {formik.touched.fax && formik.errors.fax ? (
                            <div className="text-danger">{formik.errors.fax}</div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      {/* Mobile Field */}
                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="mobile">
                            Mobile 
                          </Label>
                          <Input
                            id="mobile"
                            name="mobile"
                            type="text"
                            maxLength={15}
                            value={formik.values.mobile}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.mobile && formik.errors.mobile}
                          />
                          {formik.touched.mobile && formik.errors.mobile ? (
                            <div className="text-danger">{formik.errors.mobile}</div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      {/* Email Field */}
                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="email">
                            Email
                          </Label>
                          <Input
                            id="email"
                            name="email"
                            type="email"
                            maxLength={50   }
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.email && formik.errors.email}
                          />
                          {formik.touched.email && formik.errors.email ? (
                            <div className="text-danger">{formik.errors.email}</div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      {/* Submit and Cancel Buttons */}
                      <Col md={6} sm={12} className="d-flex justify-content-end align-items-center">
                        <div className="d-flex justify-content-end">
                          <Button
                            type="submit"
                            color="primary"
                            className="btn button-save me-2"
                            disabled={formik.isSubmitting}  // Disable button while submitting
                          ><i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                            {/* {formik.isSubmitting ? (
                              <>
                                <Spinner size="sm" /> Processing...
                              </>
                            ) : (
                              isEdit ? "Update" : "Save"
                            )} */}
                          </Button>
                          <Button type="button" color="secondary" onClick={() => {
                            formik.resetForm();
                            setIsEdit(false);
                          }} className="btn button-cancel">
                            <i className="fas fa-sync me-1" /> Cancel
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            )}

              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={units && units.length > 0 ? units : []}
                    isGlobalFilter={true}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>


  );
};

export default Unit;
